import { ItemType } from "@core/FileStructue/Item/ItemType";
import type { CategoryLink, ItemLink } from "@ext/navigation/NavigationLinks";

export type CatalogTemplateBlock = { kind: "self" } | { kind: "inside"; title: string } | null;

const findCatalogTemplateUser = (links: ItemLink[]): ItemLink | undefined => {
	for (const link of links) {
		if (link.options?.usesCatalogTemplate) return link;
		const inside = link.type === ItemType.category && findCatalogTemplateUser((link as CategoryLink).items);
		if (inside) return inside;
	}
};

/** Whether the item, or an article in its section, uses a template of its own catalog and so cannot leave it. */
export const catalogTemplateBlock = (link?: ItemLink): CatalogTemplateBlock => {
	if (!link) return null;
	if (link.options?.usesCatalogTemplate) return { kind: "self" };
	if (link.type !== ItemType.category) return null;
	const inside = findCatalogTemplateUser((link as CategoryLink).items);
	return inside ? { kind: "inside", title: inside.title } : null;
};
